<div class="card mb-0 h-full flex flex-col">
  <div class="flex justify-between items-start mb-3">
    <div>
      <span class="block text-muted-color font-medium text-sm mb-2">Success Rate (Today)</span>
      <div class="text-surface-900 dark:text-surface-0 font-bold text-2xl">{{ getSuccessRate() }}%</div>
    </div>
    <div class="flex items-center justify-center bg-green-100 dark:bg-green-400/10 rounded-lg" style="width: 2.25rem; height: 2.25rem">
      <i class="pi pi-chart-line text-green-500 text-lg"></i>
    </div>
  </div>
  <div class="space-y-2">
    <div class="flex justify-between text-xs">
      <span class="text-muted-color">Completed: {{ completedRuns }}</span>
      <span class="text-muted-color">Failed: {{ failedRuns }}</span>
    </div>
    <div class="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5">
      <div 
        class="bg-gradient-to-r from-green-500 to-green-600 h-1.5 rounded-full transition-all duration-300" 
        [style.width.%]="getSuccessRate()">
      </div>
    </div>

  </div>
</div>
